<div class="border-radius flex flex-col gap-[10px] overflow-hidden bg-background-secondary px-[10px] py-[15px]">
  <h1 class="block py-[10px] text-[28px]">Dashboard</h1>

  <div class="keen-slider min-h-[87px]" #statsSlider (drag)="test($event)">
    @for (dataItem of aggregatedData(); track dataItem.title) {
      <ng-template #chainTemp>
        <div class="flex flex-col gap-[10px]">
          <div class="flex items-center">
            <img class="mr-[5px]" src="assets/images/tokens/bsc-white-bg.svg" alt="asd" />
            {{ dataItem.skipPipeFormat ? dataItem.data.bsc : (dataItem.data.bsc | format: dataItem.formatParams) }}
          </div>
          <div class="flex items-center">
            <img class="mr-[5px]" src="assets/images/tokens/base-white-bg.svg" alt="asd" />
            {{ dataItem.skipPipeFormat ? dataItem.data.base : (dataItem.data.base | format: dataItem.formatParams) }}
          </div>
          <div class="flex items-center">
            <img class="mr-[5px]" src="assets/images/tokens/eth-white-bg.svg" alt="asd" />
            {{ dataItem.skipPipeFormat ? dataItem.data.eth : (dataItem.data.eth | format: dataItem.formatParams) }}
          </div>
        </div>
      </ng-template>

      <div class="keen-slider__slide data-card">
        <div class="flex justify-between">
          <div class="text-[12px] text-dirty-white">{{ dataItem.title }}</div>
          <cmp-popper-icon [content]="chainTemp" tpClassName="data-card__chains"></cmp-popper-icon>
        </div>

        <div class="text-gradient text-gradient--yellow mt-[15px] flex justify-end text-[40px] font-bold">
          {{ dataItem.skipPipeFormat ? dataItem.data.total : (dataItem.data.total | format: dataItem.formatParams) }}
        </div>

        <div class="data-card__chain-data flex justify-between">
          <div class="flex items-center">
            <img class="mr-[5px]" src="assets/images/tokens/bsc-white-bg.svg" alt="asd" />
            {{ dataItem.skipPipeFormat ? dataItem.data.bsc : (dataItem.data.bsc | format: dataItem.formatParams) }}
          </div>
          <div class="flex items-center">
            <img class="mr-[5px]" src="assets/images/tokens/base-white-bg.svg" alt="asd" />
            {{ dataItem.skipPipeFormat ? dataItem.data.base : (dataItem.data.base | format: dataItem.formatParams) }}
          </div>
          <div class="flex items-center">
            <img class="mr-[5px]" src="assets/images/tokens/eth-white-bg.svg" alt="asd" />
            {{ dataItem.skipPipeFormat ? dataItem.data.eth : (dataItem.data.eth | format: dataItem.formatParams) }}
          </div>
        </div>
      </div>
    }
  </div>

  @if (!screenSizeService.isFullWeb()) {
    <ng-container [ngTemplateOutlet]="fegCompTemp"></ng-container>
  }

  <ng-template #fegCompTemp>
    <div class="feg-data-card {{ screenSizeService.isFullWeb() ? 'max-w-[420px]' : 'max-w-full' }}">
      <div class="mr-[50px] flex flex-col">
        <div class="feg-data-card__header">
          <cmp-pair-logo name="FEG" url="assets/icons/feg-logo-white-background.png" sizeName="large"></cmp-pair-logo>
          <div>
            <h2 class="mb-[2px] ml-[10px]">FEED EVERY GORILLA</h2>
            <h3 class="mb-0 ml-[10px]">FEG</h3>
          </div>
        </div>

        <div class="z-[1] flex gap-[10px]">
          <a class="feg-data-card__link" [routerLink]="['..', 'token', '0xF3c7CECF8cBC3066F9a87b310cEBE198d00479aC']">
            <img class="mr-[5px]" ngSrc="assets/icons/exchange-vector.svg" [height]="14" [width]="12" alt="Exchange symbol" />
            Buy
          </a>

          <a
            class="feg-data-card__link"
            [routerLink]="['..', 'token', '0xF3c7CECF8cBC3066F9a87b310cEBE198d00479aC', { outlets: { primary: 'chart', secondary: 'staking' } }]"
          >
            <img class="mr-[5px]" ngSrc="assets/icons/stake-vector.svg" [height]="14" [width]="12" alt="Exchange symbol" />
            Stake
          </a>

          <a
            class="feg-data-card__link"
            [routerLink]="['..', 'token', '0xF3c7CECF8cBC3066F9a87b310cEBE198d00479aC', { outlets: { primary: 'chart', secondary: 'bridge' } }]"
          >
            <img class="mr-[5px]" ngSrc="assets/icons/bridge-vector.svg" [height]="12" [width]="13" alt="Exchange symbol" />
            Bridge
          </a>
        </div>
        <img class="absolute right-0 top-0 h-full" src="assets/icons/feg-card-coin.png" alt="FEG coin visual" />
      </div>
    </div>
  </ng-template>
  <!-- </div> -->
  <!-- <div class="flex items-center justify-between my-[10px]">
          <div>
            <div class="text-center text-dirty-white mr-[10px]">
              <div class="font-semibold ml-[5px] text-[18px] mb-[10px] text-white">
                {{ chainTokens()?.length }}
              </div>
              <div class="text-[12px] font-normal">{{ chain() | uppercase }} tokens</div>
            </div>
          </div>

          <div class="text-dirty-white mr-[10px]">
            <div class="text-center font-semibold ml-[5px] text-[24px] mb-[10px] text-white">
              ${{ totalChainVolume() | format }}
            </div>
            <div class="text-[12px] font-normal">Total {{ chain() | uppercase }} 24h volume</div>
          </div>
        </div> -->
  <!-- </div> -->

  <div class="flex gap-[10px] max-mobile-medium:flex-col">
    <div class="info min-h-[336px] w-1/2 pb-[10px] max-mobile-medium:w-full">
      <div class="flex items-center text-[18px] font-semibold">
        SmartDeFi Top Gainers
        <cmp-popper-icon class="ml-[2px] pt-[5px] text-[14px]" [content]="topGainersTooltip()"></cmp-popper-icon>
      </div>
      <div class="mt-[20px] flex justify-between text-[13px] text-dirty-white">
        <div class="flex">
          <div class="w-[20px]">#</div>
          Name
        </div>
        <div class="">Change 24h</div>
      </div>

      <div class="info__item" *rxFor="let token of trendingTokens(); trackBy: 'id'; let i = index">
        <button class="flex cursor-pointer items-center text-text-secondary" (click)="openTokenPreview(token.address)">
          <div class="w-[20px]">{{ i + 1 }}</div>
          <cmp-pair-logo class="mr-[15px]" [url]="token.logoURI" [name]="token.symbol" [priority]="true"></cmp-pair-logo>
          <div class="flex flex-col items-start gap-[2px] text-left">
            <span class="text-[16px] font-semibold text-white max-mobile-msmall:text-[14px]">{{ token.name }}</span>
            <span class="text-[12px] font-light text-dirty-white">{{ token.symbol }}</span>
          </div>
        </button>
        <div class="{{ +token?.priceChange < 0 ? 'text-danger' : 'text-success' }}">
          {{ +token?.priceChange > 0 ? '+' : '' }}{{ token?.priceChange | format: { decimals: 2 } }}%
        </div>
      </div>
    </div>

    <div class="info w-1/2 pb-[10px] max-mobile-medium:w-full">
      <div class="flex items-center text-[18px] font-semibold">
        New SD listings
        <cmp-popper-icon class="ml-[2px] pt-[5px] text-[14px]" [content]="newListingsTooltip()"></cmp-popper-icon>
      </div>
      <div class="mt-[20px] flex justify-between text-[13px] text-dirty-white">
        <div class="flex">Name</div>
        <div class="">Price</div>
      </div>

      <div class="info__item" *rxFor="let token of newListings(); trackBy: 'id'; let i = index">
        <button class="flex cursor-pointer items-center text-text-secondary" (click)="openTokenPreview(token.address)">
          <cmp-pair-logo class="mr-[15px]" [url]="token.logoURI" [name]="token.symbol" [priority]="true"></cmp-pair-logo>
          <div class="flex flex-col items-start gap-[2px] text-left">
            <span class="text-[16px] font-semibold text-white max-mobile-msmall:text-[14px]">{{ token.name }}</span>
            <span class="text-[12px] font-light text-dirty-white">{{ token.symbol }}</span>
          </div>

          <!-- <div>
            <span class="text-[16px] font-semibold text-white">{{ token.name }}</span>
            <span class="ml-[5px] font-light text-dirty-white">{{ token.symbol }}</span>
          </div> -->
        </button>
        <div class="{{ token.lastMethod === 'sell' ? 'text-danger' : 'text-success' }}">${{ token.tokenPriceUSD | format: { toSubscript: true } }}</div>
      </div>
    </div>
  </div>

  <div
    class="border-radius flex items-center bg-background-white px-[15px] py-[5px] text-[16px] max-mobile-msmall:text-[14px] max-mobile-medium:flex-col max-mobile-medium:py-[10px]"
  >
    <div class="flex items-center max-mobile-msmall:w-full max-mobile-msmall:px-[5px] max-mobile-medium:justify-between">
      <div class="flex items-center">
        <img
          ngSrc="assets/icons/smart-defi-small.png"
          height="40"
          width="40"
          alt="SmartDeFi logo"
          class="h-[40px] w-[40px] rounded-full max-mobile-msmall:h-[30px] max-mobile-msmall:w-[30px]"
        />
        <div class="ml-[10px] font-semibold max-mobile-medium:mr-[15px]">SmartDeFi&trade;</div>
      </div>
      @if (screenSizeService.isFullWeb()) {
        <div class="ml-[8px] font-light">Fully Audited Token Launch-Pad for anyone to create a Cryptocurrency!</div>
      }
      <div class="ml-[8px] font-semibold">Launch your token today!</div>
    </div>
    @if (screenSizeService.isMobile()) {
      <div class="ml-[8px] mt-[10px] font-light max-mobile-msmall:text-center">Fully Audited Token Launch-Pad for anyone to create a Cryptocurrency!</div>
    }
  </div>

  <cmp-token-table></cmp-token-table>
</div>
<!-- @if (width() > 1530) { -->
@if (screenSizeService.isFullWeb()) {
  <div class="flex flex-col gap-[10px]">
    <ng-container [ngTemplateOutlet]="fegCompTemp"></ng-container>

    @defer {
      <cmp-token-info-list></cmp-token-info-list>
    } @placeholder {
      <div class="border-radius w-[420px] flex-none bg-background-secondary"></div>
    }
  </div>
}
<!-- } -->
<!-- </div> -->
